import { useContext } from 'react';
import ErrorContext from "../../contexts/errorContext.js";

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/esm/Button.js';
import Typewriter from '../Typewriter.jsx';

export const InfoModal = () => {
    const { errorContext, setErrorContext } = useContext(ErrorContext);
    
    const manualClose = errorContext?.manualClose || false;
    const useTypewriter = errorContext?.useTypewriter || false;
    const size = errorContext?.size || 'md';
    let title = errorContext?.title;
    let body = errorContext?.body;
    let buttons = errorContext?.buttons;
    let iconClass = errorContext?.iconClass || 'bi-x-octagon pe-3 danger-color';
    
    let closeTimer;
    const doClose = () => {
        clearTimeout(closeTimer);
        setErrorContext(undefined);
    }

    if (typeof errorContext === 'undefined') {
        return <></>
    } else {
        if (!manualClose) {
            closeTimer = setTimeout(() => {
                doClose();
            }, errorContext.duration || 1800);
        }
    }

    if (errorContext.event) {
        errorContext.event.stopPropagation();
    }

    switch(errorContext.type) {
        case 'info':
            iconClass = 'bi-info-circle pe-3 a8-blue'
            break;
        case 'comingSoon':
            title = title || 'Coming soon!';
            body = body || 'Stay tuned...';
            iconClass = 'bi-rocket-takeoff pe-3 text-muted'
            break;
    }

    return (
        <Modal
            show={true}
            size={size}
            className='text-muted'
            onHide={doClose}
        >
            <Modal.Header closeButton>
                <i className={iconClass} style={{"fontSize":"1.5em"}} />
                <Modal.Title style={{"fontFamily":"PP Neue Montreal"}}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {useTypewriter ? (
                    <Typewriter text={body} />
                ) : (
                    <>{body}</>
                )}
                
            </Modal.Body>
            <Modal.Footer>
                {buttons && buttons.map(button => { 
                    const onClick = () => {
                        button.onClick ? button.onClick() : console.log('no onClick');
                        doClose();
                    }
                    
                    return (
                        <Button
                            variant={button.variant || 'primary'}
                            className={button.className}
                            onClick={onClick}
                        >
                            {button.content}
                        </Button>
                    )
                })}
            </Modal.Footer>
        </Modal>
    )
}